import { CheckIcon } from '@systemeio/icons'
import { Loader } from 'shared/components'

export const getStateStatusIcon = (isLoading: boolean, isSuccess?: boolean) => {
  if (isLoading) {
    return <Loader small />
  }
  if (isSuccess) {
    return <CheckIcon className="text-icon-success size-5" />
  }
}
